import produce from 'immer';
import { WritableDraft } from 'immer/dist/internal';
import { Actions } from './action';
import { AvcState } from './interface';
import { AvcActions, Inputs } from './enum';
import { FormType } from 'Container/App/enum';

export const initialState: AvcState = {
    loading: false,
    error: undefined,
    addressForm: {
        type: FormType.ADDRESS,
        city: '',
        street: '',
        number: '',
        index: -1,
        touched: false,
    },
    addresses: [],
    accessSupplier: undefined,
    availabilityIndicator: undefined,
};

const setForm = (draft: WritableDraft<AvcState>, index: number = 0) => {
    draft.addressForm.touched = false;

    const address = draft.addresses[index];

    if (!address) {
        return;
    }

    draft.addressForm.city = address.city ?? '';
    draft.addressForm.street = address.street ?? '';
    draft.addressForm.number = (address.housenumber ?? '') + (address.housenumberextra ?? '');
    draft.addressForm.index = index;
};

const setInput = (draft: WritableDraft<AvcState>, name: Inputs, value: string) => {
    if (draft.addressForm[name] === value) {
        return;
    }

    draft.addressForm[name] = value;
    draft.addressForm.touched = true;
    draft.addressForm.index = -1;
};

const avcReducer = (state = initialState, action: Actions) =>
    produce(state, draft => {
        switch (action.type) {
            case AvcActions.SET_LOADING:
                draft.loading = action.loading;
                break;
            case AvcActions.SET_ERROR:
                draft.error = action.error;
                break;
            case AvcActions.SET_ADDRESS_INPUT:
                setInput(draft, action.name, action.value);
                break;
            case AvcActions.SET_ADDRESS_FORM:
                setForm(draft, action.index);
                break;
            case AvcActions.SET_ADDRESSES:
                draft.addresses = action.addresses;
                setForm(draft);
                break;
            case AvcActions.RESET_FORM:
                draft.addressForm = { ...initialState.addressForm };
                draft.addresses = [];
                break;
            case AvcActions.SET_ACCESS_SUPPLIER:
                draft.accessSupplier = action.accessSupplier;
                break;
            case AvcActions.SET_AVAILABILITY_INDICATOR:
                draft.availabilityIndicator = action.availabilityIndicator;
                break;
        }
    });

export default avcReducer;
